import { Highlight } from 'react-instantsearch-hooks-web';
import { formatZip } from '../../../../lib/utils/formatters';

export const highlightMatches = (result) => {
  const keys = Object.keys(result?._highlightResult);

  return keys.map((k) => {
    if (result?._highlightResult[k].matchLevel === 'full') {
      return (
        <span key={k} className="ph-no-capture">
          <Highlight attribute={k} hit={result} /> ({k?.replace('_', ' ')})
        </span>
      );
    }
    return null;
  });
};

export const address = (address) => {
  return (
    <span className="ph-no-capture">
      {address?.address1} {address?.address2} {address?.city}, {address?.state}{' '}
      {formatZip(address?.zip)}
    </span>
  );
};
